
import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import ArticleHero from './components/ArticleHero';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import ArticleCategories from './components/ArticleCategories';

export default function Articles() {
  const [selectedCategory, setSelectedCategory] = useState<string>('すべて');

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <Header />
      <main>
        <ArticleHero />
        <FeaturedArticles />
        <LatestArticles />
        <ArticleCategories 
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}